module.exports = __webpack_public_path__ + "img/service-and-shop-filter-cjdr.1536be40.jpg";